import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { sanitizeExtraAttributes } from '../../ai-answer-dialog/analytics-helpers';
export var fetchCuratedDefinitionErrorPayload = function fetchCuratedDefinitionErrorPayload(error, commonAttributes) {
  var _error$stack;
  var extraAttributes = commonAttributes.extraAttributes,
    source = commonAttributes.source;
  return {
    action: 'failed',
    actionSubject: 'aiCuratedDefinitionFetch',
    source: source,
    eventType: 'track',
    attributes: _objectSpread(_objectSpread({}, sanitizeExtraAttributes(extraAttributes)), {}, {
      errorName: error instanceof Object && 'name' in error ? error.name : '',
      errorMessage: error instanceof Object && 'message' in error ? error.message : '',
      errorStack: error instanceof Object && 'stack' in error && typeof error.stack === 'string' ? (_error$stack = error.stack) === null || _error$stack === void 0 ? void 0 : _error$stack.split('\n').at(1) : ''
    })
  };
};
export var fetchPrecomputedDefinitionErrorPayload = function fetchPrecomputedDefinitionErrorPayload(error, commonAttributes) {
  var _error$stack2;
  var extraAttributes = commonAttributes.extraAttributes,
    source = commonAttributes.source;
  return {
    action: 'failed',
    actionSubject: 'aiPrecomputedDefinitionFetch',
    source: source,
    eventType: 'track',
    attributes: _objectSpread(_objectSpread({}, sanitizeExtraAttributes(extraAttributes)), {}, {
      errorName: error instanceof Object && 'name' in error ? error.name : '',
      errorMessage: error instanceof Object && 'message' in error ? error.message : '',
      errorStack: error instanceof Object && 'stack' in error && typeof error.stack === 'string' ? (_error$stack2 = error.stack) === null || _error$stack2 === void 0 ? void 0 : _error$stack2.split('\n').at(1) : ''
    })
  };
};
export var updateDefinitionErrorPayload = function updateDefinitionErrorPayload(error, commonAttributes) {
  var _error$stack3;
  var extraAttributes = commonAttributes.extraAttributes,
    source = commonAttributes.source;
  return {
    action: 'failed',
    actionSubject: 'aiCuratedDefinitionUpdate',
    source: source,
    eventType: 'track',
    attributes: _objectSpread(_objectSpread({}, sanitizeExtraAttributes(extraAttributes)), {}, {
      errorName: error instanceof Object && 'name' in error ? error.name : '',
      errorMessage: error instanceof Object && 'message' in error ? error.message : '',
      errorStack: error instanceof Object && 'stack' in error && typeof error.stack === 'string' ? (_error$stack3 = error.stack) === null || _error$stack3 === void 0 ? void 0 : _error$stack3.split('\n').at(1) : ''
    })
  };
};
export var toggleDefinitionErrorPayload = function toggleDefinitionErrorPayload(error, commonAttributes) {
  var _error$stack4;
  var extraAttributes = commonAttributes.extraAttributes,
    source = commonAttributes.source;
  return {
    action: 'failed',
    actionSubject: 'aiDefinitionToggle',
    source: source,
    eventType: 'track',
    attributes: _objectSpread(_objectSpread({}, sanitizeExtraAttributes(extraAttributes)), {}, {
      errorName: error instanceof Object && 'name' in error ? error.name : '',
      errorMessage: error instanceof Object && 'message' in error ? error.message : '',
      errorStack: error instanceof Object && 'stack' in error && typeof error.stack === 'string' ? (_error$stack4 = error.stack) === null || _error$stack4 === void 0 ? void 0 : _error$stack4.split('\n').at(1) : ''
    })
  };
};